import React from "react";
import { AlertTriangle, Camera, Copy, Pencil, Printer, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TableCell, TableRow } from "@/components/ui/table";
import { RowCheckbox } from "@/components/BulkSelectionBar";

export default function ProductRow({ p, bulk, categories, rates, imgSrc, fmtMoney, onUploadImage, onPrintLabel, onEdit, onDuplicate, onDelete }) {
  const low = p.stock <= p.min_stock && p.min_stock > 0;
  return <TableRow
    key={p.id}
    data-testid={`product-row-${p.id}`}
    data-state={bulk.isSelected(p.id) ? "selected" : ""}
    className={`${bulk.isSelected(p.id) ? "bg-primary/5" : ""} cursor-grab active:cursor-grabbing`}
    draggable
    onDragStart={(e) => {
      const ids = bulk.isSelected(p.id) && bulk.count > 0 ? bulk.selectedIds : [p.id];
      e.dataTransfer.setData("application/x-muhasabaty-products", JSON.stringify({ product_ids: ids }));
      e.dataTransfer.effectAllowed = "copy";
    }}
  >
    <TableCell><RowCheckbox bulk={bulk} id={p.id} /></TableCell>
    <TableCell>
      <label className="cursor-pointer inline-block" title="اضغط لرفع صورة">
        {p.image_url ? <img src={imgSrc(p.image_url)} alt="" className="w-10 h-10 rounded object-cover border border-border" /> : <div className="w-10 h-10 rounded bg-muted border border-dashed border-border grid place-items-center text-muted-foreground hover:bg-accent"><Camera className="w-4 h-4" /></div>}
        <input type="file" accept="image/*" className="hidden" onChange={(e) => onUploadImage(p.id, e.target.files[0], e.target)} data-testid={`upload-image-${p.id}`} />
      </label>
    </TableCell>
    <TableCell className="font-semibold">
      {p.name}
      {(() => {
        const tags = p.categories && p.categories.length ? p.categories : (p.category ? [p.category] : []);
        if (!tags.length) return null;
        return <div className="text-[10px] mt-0.5 flex flex-wrap gap-1">{tags.map(tag => {
          const cat = categories.find(c => c.name === tag);
          return <span key={tag} className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded" style={{ background: `${cat?.color || "#94a3b8"}20`, color: cat?.color || "#475569" }}><span className="w-1.5 h-1.5 rounded-full" style={{ background: cat?.color || "#94a3b8" }} />{tag}</span>;
        })}</div>;
      })()}
    </TableCell>
    <TableCell className="tabular-nums text-xs">{p.barcode}</TableCell>
    <TableCell className="tabular-nums text-xs font-mono" data-testid={`product-plu-${p.id}`}>{p.plu || "—"}</TableCell>
    <TableCell className="tabular-nums">{fmtMoney(p.cost_price, p.currency)}</TableCell>
    <TableCell className="tabular-nums font-semibold">
      {fmtMoney(p.sale_price, p.currency)}
      {Number(rates[p.currency]) > 0 && Number(rates.USD) > 0 && p.currency !== "USD" && <div className="text-[10px] text-muted-foreground font-normal">≈ {fmtMoney((Number(p.sale_price) * Number(rates[p.currency])) / Number(rates.USD), "USD")}</div>}
      {Number(rates[p.currency]) > 0 && Number(rates.SYP) > 0 && p.currency !== "SYP" && <div className="text-[10px] text-muted-foreground font-normal">≈ {fmtMoney((Number(p.sale_price) * Number(rates[p.currency])) / Number(rates.SYP), "SYP")}</div>}
    </TableCell>
    <TableCell className={`tabular-nums font-bold ${low ? "text-destructive" : ""}`}>{low && <AlertTriangle className="w-3 h-3 inline me-1" />}{p.stock}</TableCell>
    <TableCell className="text-xs">{p.expiry_date || "—"}</TableCell>
    <TableCell><div className="flex gap-1">
      <Button size="sm" variant="ghost" onClick={() => onPrintLabel(p)} title="طباعة باركود"><Printer className="w-4 h-4" /></Button>
      <Button size="sm" variant="ghost" onClick={() => onEdit(p)} data-testid={`edit-product-${p.id}`}><Pencil className="w-4 h-4" /></Button>
      <Button size="sm" variant="ghost" className="text-blue-600" title="نسخ صنف" onClick={() => onDuplicate(p)} data-testid={`duplicate-product-${p.id}`}><Copy className="w-4 h-4" /></Button>
      <Button size="sm" variant="ghost" className="text-destructive" onClick={() => onDelete(p)} data-testid={`delete-product-${p.id}`}><Trash2 className="w-4 h-4" /></Button>
    </div></TableCell>
  </TableRow>;
}
